import styles from './styles/SubTabs.module.scss';
import React from 'react';
import { SubItemsSkeleton } from './SubItems.skeleton';
const widths = [4.5, 7, 6, 5, 8];
export const SubTabsSkeleton = () => {
    return React.createElement(React.Fragment, null,
        React.createElement("div", { className: `pos:r ${styles.wrapper}` },
            React.createElement("ul", { className: `list:none d:grid gaf:column jc:start ov:h w:100p ${styles.items}` }, widths.map((w, i) => (React.createElement("li", { key: i, className: styles.item, style: { width: `${w}em` } },
                React.createElement("span", { className: "d:block skeleton bdrs:2", style: { height: '1.375em' } })))))),
        React.createElement(SubItemsSkeleton, null));
};
